// The netplay page (/netplay) hosts two views of one React app: Play and Chat.
// /netplay opens Play; /netplay/chat (and a room link, /netplay/{room id}) opens Chat. Switching between them on the
// page is client-side (pushState + popstate) so the socket and any search stay alive.

export const NETPLAY_VIEWS = Object.freeze({
	play: 'play',
	chat: 'chat',
});

const VIEW_CHANGE_EVENT = 'netplayviewchange';
// /netplay/{piece}: "chat", or a room link (/netplay/{room id}, see Chat_Room's url),
// opens Chat. "index" is the bare page.
const NETPLAY_SUB_PATH_PATTERN = /\/netplay\/([^/]+)\/?$/;

export function viewFromPathname(pathname) {
	const match = NETPLAY_SUB_PATH_PATTERN.exec(pathname);
	if(!match || match[1] === 'index') {
		return NETPLAY_VIEWS.play;
	}
	return NETPLAY_VIEWS.chat;
}

export function pathForView(view, currentPathname = window.location.pathname) {
	const netplayIndex = currentPathname.indexOf('/netplay');
	const netplayBase = netplayIndex === -1
		? '/netplay'
		: currentPathname.slice(0, netplayIndex + '/netplay'.length);
	return view === NETPLAY_VIEWS.chat ? `${netplayBase}/chat` : netplayBase;
}

export function currentView() {
	return viewFromPathname(window.location.pathname);
}

export function navigateToView(view) {
	if(currentView() === view) {
		return;
	}
	window.history.pushState({ netplayView: view }, '', pathForView(view));
	window.dispatchEvent(new CustomEvent(VIEW_CHANGE_EVENT, { detail: view }));
}

export function subscribeToViewChanges(listener) {
	const notify = () => listener(currentView());
	window.addEventListener('popstate', notify);
	window.addEventListener(VIEW_CHANGE_EVENT, notify);
	return () => {
		window.removeEventListener('popstate', notify);
		window.removeEventListener(VIEW_CHANGE_EVENT, notify);
	};
}
